import Vue from 'vue'
import Vuex from 'vuex'
import { firebaseAuth, firebaseDatabase } from '@/services/firebase'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    boards: [],
  },
  mutations: {
    setBoards(state, payload) {
      state.boards = payload
    },
    insertBoard(state, payload) {
      state.boards.push(payload)
    },
  },
  actions: {
    async getBoards(context) {
      const boardsPayload = []
      firebaseDatabase.collection('boards')
        .where('userID', '==', firebaseAuth.currentUser.uid)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            const data = {
              boardID: doc.id,
              boardName: doc.data().boardName,
              boardDescription: doc.data().boardDescription,
              userID: doc.data().userID,
              img1: doc.data().img1,
              img2: doc.data().img2,
              img3: doc.data().img3,
              img4: doc.data().img4,
            }
            boardsPayload.push(data)
          })
        })

      context.commit('setBoards', boardsPayload)
    },
  },
  getters: {
    state: state => state,
  },
}
